import axios from '../libs/axios';

// Takvim API servisleri
class CalendarService {
  constructor() {
    this.baseURL = '/users';
    this.dashboardBaseURL = '/dashboard';
  }

  // 🆕 YENİ: Tüm takvim öğelerini getir (kapsamlı)
  async getAllCalendarItems(token) {
    try {
      const response = await axios.get(`${this.baseURL}/all-calendar-items`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      return response.data || { calendar_items: [], summary: {} };
    } catch (error) {
      console.error('Takvim öğeleri getirilemedi:', error);
      throw error;
    }
  }

  // 🆕 YENİ: Tek tarihli takvim verileri
  async getDateData(date, token) {
    try {
      const response = await axios.post(`${this.baseURL}/date`, 
        { date: date },
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );
      return response.data || { date: date, events: [], tasks: [], notes: [] };
    } catch (error) {
      console.error('Tarih verisi getirilemedi:', error);
      throw error;
    }
  }

  // 🆕 YENİ: Tüm tarihli veriler
  async getAllDates(token) {
    try {
      const response = await axios.get(`${this.baseURL}/dates`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      return response.data || { dates: {} };
    } catch (error) {
      console.error('Tüm tarihli veriler getirilemedi:', error);
      throw error;
    }
  }

  // Tek takvim etkinliği getir
  async getEventById(eventId, token) {
    try {
      // Event ID'sini temizle (type-id formatından sadece id'yi al)
      const cleanEventId = eventId.toString().replace(/^(calendar_event|user_task|user_note|project_task|reminder)-/, '');
      
      const response = await axios.post(`${this.baseURL}/date`, 
        { eventid: cleanEventId },
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );
      
      // API [200, event] formatında döner
      if (response.data && Array.isArray(response.data) && response.data[0] === 200) {
        return response.data[1];
      }
      return null;
    } catch (error) {
      console.error('Takvim etkinliği getirilemedi:', error);
      throw error;
    }
  }

  // Yeni takvim etkinliği oluştur
  async createEvent(eventData, token) {
    try {
      const response = await axios.post(`${this.baseURL}/date/set`, eventData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      // API 200 döner başarılı olursa
      return response.data === 200;
    } catch (error) {
      console.error('Takvim etkinliği oluşturulamadı:', error);
      throw error;
    }
  }

  // Takvim etkinliği güncelle
  async updateEvent(eventData, token) {
    try {
      // Event ID'sini temizle (type-id formatından sadece id'yi al)
      const cleanEventData = { ...eventData };
      if (cleanEventData.id) {
        cleanEventData.id = cleanEventData.id.toString().replace(/^(calendar_event|user_task|user_note|project_task|reminder)-/, '');
      }
      
      const response = await axios.post(`${this.baseURL}/date/update`, cleanEventData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      // API 200 döner başarılı olursa
      return response.data === 200;
    } catch (error) {
      console.error('Takvim etkinliği güncellenemedi:', error);
      throw error;
    }
  }

  // Takvim etkinliği sil
  async deleteEvent(eventId, token) {
    try {
      // Event ID'sini temizle (type-id formatından sadece id'yi al)
      const cleanEventId = eventId.toString().replace(/^(calendar_event|user_task|user_note|project_task|reminder)-/, '');
      
      const response = await axios.post(`${this.baseURL}/date/delete`, 
        { eventid: cleanEventId },
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );
      
      // API 200 döner başarılı olursa
      return response.data === 200;
    } catch (error) {
      console.error('Takvim etkinliği silinemedi:', error);
      throw error;
    }
  }

  // 🆕 YENİ: Dashboard yaklaşan öğeler (kapsamlı)
  async getUpcomingItems(token) {
    try {
      const response = await axios.get(`${this.dashboardBaseURL}/upcoming-items`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      return response.data || { upcomingItems: [], summary: {} };
    } catch (error) {
      console.error('Yaklaşan öğeler getirilemedi:', error);
      throw error;
    }
  }

  // Dashboard için yaklaşan etkinlikler (eski API - geriye uyumluluk)
  async getUpcomingEvents(token) {
    try {
      const response = await axios.get(`${this.dashboardBaseURL}/userlastcalendars`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      return response.data.lastCalendars || [];
    } catch (error) {
      console.error('Yaklaşan etkinlikler getirilemedi:', error);
      throw error;
    }
  }

  // 🆕 YENİ: Utility fonksiyonlar - Kapsamlı takvim öğeleri için
  formatCalendarItemForCalendar(item) {
    // Öncelik bilgisini normalize et (backend priority/c_priority veya varsayılan 1)
    const rawPriority = item?.priority ?? item?.c_priority ?? 1;
    const normalizedPriority = Number.isFinite(parseInt(rawPriority)) ? parseInt(rawPriority) : 1;

    return {
      id: `${item.type}-${item.id}`,
      title: item.title,
      start: new Date(parseInt(item.start)),
      end: new Date(parseInt(item.end)),
      extendedProps: {
        type: item.type,
        description: item.description,
        priority: normalizedPriority,
        status: item.status,
        project_name: item.project_name,
        project_slug: item.project_slug
      }
    };
  }

  formatCalendarItemsForCalendar(items) {
    // Sadece takvimde oluşturulan etkinlikleri göster (görev, hatırlatıcı, not vb. hariç)
    return items
      .filter(item => item && item.type === 'calendar_event')
      .map(item => this.formatCalendarItemForCalendar(item));
  }

  // Utility fonksiyonlar - Eski API için (geriye uyumluluk)
  formatEventForCalendar(event) {
    return {
      id: event.id.toString(),
      title: event.c_title,
      start: new Date(parseInt(event.c_start)),
      end: new Date(parseInt(event.c_end)),
      extendedProps: {
        description: event.c_desc,
        priority: event.c_priority,
        calendar: event.c_priority // FullCalendar için renk kategorisi
      }
    };
  }

  formatEventsForCalendar(events) {
    return events.map(event => this.formatEventForCalendar(event));
  }

  // Date objesini timestamp'e çevir
  dateToTimestamp(date) {
    return date.getTime().toString();
  }

  // Timestamp'i Date objesine çevir
  timestampToDate(timestamp) {
    return new Date(parseInt(timestamp));
  }

  // Tarih formatla (Türkçe)
  formatDateTime(timestamp) {
    const date = this.timestampToDate(timestamp);
    return date.toLocaleString('tr-TR', {
      day: '2-digit',
      month: 'long',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  // 🆕 YENİ: Öğe tipi ikonunu getir
  getItemTypeIcon(type) {
    const icons = {
      'calendar_event': '📅',
      'user_task': '✅',
      'user_note': '📝',
      'project_task': '🎯',
      'reminder': '⏰'
    };
    return icons[type] || '📌';
  }

  // 🆕 YENİ: Öğe tipi etiketini getir
  getItemTypeLabel(type) {
    const labels = {
      'calendar_event': 'Etkinlik',
      'user_task': 'Kişisel Görev',
      'user_note': 'Not',
      'project_task': 'Proje Görevi',
      'reminder': 'Hatırlatıcı'
    };
    return labels[type] || 'Bilinmiyor';
  }

  // Öncelik rengini getir
  getPriorityColor(priority) {
    const colors = {
      0: '#cddc39', // Düşük
      1: '#2196f3', // Normal
      2: '#ff9800', // Yüksek
      3: '#f44336'  // Kritik
    };
    return colors[priority] || '#2196f3';
  }

  // Öncelik metnini getir
  getPriorityText(priority) {
    const texts = {
      0: 'Düşük',
      1: 'Normal', 
      2: 'Yüksek',
      3: 'Kritik'
    };
    return texts[priority] || 'Normal';
  }
}

// Singleton instance
const calendarService = new CalendarService();

export default calendarService;

// Named exports for convenience
export const {
  getAllCalendarItems,
  getDateData,
  getAllDates,
  getEventById,
  createEvent,
  updateEvent,
  deleteEvent,
  getUpcomingItems,
  getUpcomingEvents,
  formatCalendarItemForCalendar,
  formatCalendarItemsForCalendar,
  formatEventForCalendar,
  formatEventsForCalendar,
  dateToTimestamp,
  timestampToDate,
  formatDateTime,
  getItemTypeIcon,
  getItemTypeLabel,
  getPriorityColor,
  getPriorityText
} = calendarService;
